// T3-B PR 4 (2026-05-12) / PR 4-bis (2026-05-12):
//   motif_template_sets CRUD API クライアント (omikuji-api PR #117 / #118)。
//   auth: ADMIN only。

import ApiService from './ApiService';

export default class MotifTemplateSetApi extends ApiService {
    // GET /system/motif-template-sets[?include_inactive=1]
    list(payload?: { include_inactive?: 0 | 1 }) {
        return this.get('motif-template-sets', payload);
    }

    // GET /system/motif-template-sets/:id
    getById(id: string | number) {
        return this.get(`motif-template-sets/${id}`);
    }

    // POST /system/motif-template-sets
    create(payload: any) {
        return this.post('motif-template-sets', payload);
    }

    // PUT /system/motif-template-sets/:id
    update(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`motif-template-sets/${id}`, data);
    }

    // DELETE /system/motif-template-sets/:id
    remove(id: string | number) {
        return this.delete(`motif-template-sets/${id}`);
    }
}
